import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs';
@Injectable()
export class SharedNameService {
 sharedData = {};

}
export class MessageService {
  private subject = new Subject<any>();
 sendMessage(message: string) {
     console.log(message);
        this.subject.next({ text: message });
    }

    clearMessage() {
        console.log("value Called")
        this.subject.next();
    }

    getMessage(): Observable<any> {
        return this.subject.asObservable();
    }
}



// WEBPACK FOOTER //
// ./src/app/services/sharedName.service.ts